import React from "react";
import {
  ContainerTab,
  InputCEPFormStyled,
  InputPhoneFormStyled,
  Row,
  TextFieldSearchStyled,
} from "../../styles";
import Field from "../../components/Field";
import { InputForm } from "../../../../../components/Modal/Input";
import { findAllMunicipio } from "../../../../../services/InternacaoService";
import { consultaDeCep } from "../../../../../services/EnderecoService";
import { InputDocumentos } from "../../../../../components/Input/InputDocumentos";
import { withStyles } from "@material-ui/core";

const Acompanhante = ({classes, internacao, handleField }) => {
  const { acompanhante } = internacao;
  const { nome, endereco, contato, rg, documento } = acompanhante || {};

  const { cep, nomeLogradouro, bairro, municipio, numero } = endereco || {};

  const { telefonePrincipal, telefoneSecundario } = contato || {};

  const handleFieldAcompanhante = (value, field) => {
    const dadosAcompanhante = {
      ...acompanhante,
      [field]: value
    };

    handleField("acompanhante", dadosAcompanhante);
  };

  const loadAllMunicipio = async (search, loadedOptions, { page }) => {
    const searchDTO = {
      search,
      pageNumber: page,
      pageSize: 20,
      sortDir: "ASC",
      sortField: "nome",
    };

    const response = await findAllMunicipio({ searchDTO });
    const { content, last } = response;

    return {
      options: content,
      hasMore: !last,
      additional: {
        page: page + 1,
      },
    };
  };

  const onCEPChange = async (e) => {
    const { value } = e.target;

    const cepSemMascara = value.replace(/\D/g, "");
    if (cepSemMascara.length === 8) {
      const response = await consultaDeCep(cepSemMascara);
      const responseConsultaDeCep = response?.data?.data?.consultaDeCep || {};
      if (responseConsultaDeCep) {
        const { logradouro, bairro, municipio } = responseConsultaDeCep;

        const dadosAcompanhante = {
          ...internacao.acompanhante,
          endereco: {
            cep: cepSemMascara,
            nomeLogradouro: logradouro,
            bairro,
            municipio,
            uf: municipio?.estado?.uf,
          },
        };

        handleField("acompanhante", dadosAcompanhante);
      }
    }
  };

  const handleFieldUpdate = (value, type, field) => {
    const dadosAcompanhante = {
      ...internacao.acompanhante,
      [type]: {
        ...internacao.acompanhante[type],
        [field]: value,
      },
    };

    handleField("acompanhante", dadosAcompanhante);
  };

  return (
    <ContainerTab>
      <Row>
        <Field label="Nome">
          <InputForm
            id="agd-acp-inp-nom"
            value={nome}
            onChange={(e) => handleFieldAcompanhante(e.target.value, "nome")}
          />
        </Field>
      </Row>
      <Row>
        <Field label="RG">
          <InputForm
            id="agd-acp-inp-rg"
            value={rg}
            onChange={(e) => handleFieldAcompanhante(e.target.value, "rg")}
          />
        </Field>
        <Field label="CPF">
          <InputDocumentos
            id="agd-acp-inp-cpf"
            placeholder="Documento"
            value={documento}
            onChange={(e) =>
              handleFieldAcompanhante(e.target.value, "documento")
            }
            tipo={'CPF'}
            className={classes.inputDivMask}
            classes={{ input: classes.inputMask }}
          />
        </Field>
      </Row>
      <Row>
        <Field label="Telefone principal">
          <InputPhoneFormStyled
            id="agd-acp-inp-tp1"
            value={telefonePrincipal}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "contato", "telefonePrincipal")
            }
          />
        </Field>
        <Field label="Telefone secundário">
          <InputPhoneFormStyled
            id="agd-acp-inp-tp2"
            value={telefoneSecundario}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "contato", "telefoneSecundario")
            }
          />
        </Field>
      </Row>
      <Row>
        <Field label="CEP">
          <InputCEPFormStyled
            id="agd-acp-inp-cep"
            type="text"
            onChange={(e) => onCEPChange(e)}
            value={cep}
          />
        </Field>
        <Field label="Endereço">
          <InputForm
            id="agd-acp-inp-end"
            value={nomeLogradouro}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "endereco", "nomeLogradouro")
            }
          />
        </Field>
        <Field label="Número">
          <InputForm
            id="agd-acp-inp-num"
            value={numero}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "endereco", "numero")
            }
          />
        </Field>
      </Row>
      <Row>
        <Field label="Bairro">
          <InputForm
            id="agd-acp-inp-bai"
            value={bairro}
            onChange={(e) =>
              handleFieldUpdate(e.target.value, "endereco", "bairro")
            }
          />
        </Field>
        <Field label="Cidade">
          <TextFieldSearchStyled
            id="agd-acp-sel-cid"
            placeholder="Selecione"
            loadOptions={loadAllMunicipio}
            getOptionLabel={(option) => `${option.nome} - ${option.uf}`}
            getOptionValue={(option) => option.id}
            value={municipio}
            onChange={(e) => handleFieldUpdate(e, "endereco", "municipio")}
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
          />
        </Field>
      </Row>
    </ContainerTab>
  );
};

const styles = {
  inputMask: {
    color: '#000',
    border: 'none',
    borderRadius: 0,
    fontSize: '14px',
  },
  inputDivMask: {
    background: '#F2F2F2',
    borderRadius: '8px',
    height: '32px',
    paddingLeft: '8px',
    width: 'calc(100% - 8px)',
  },
}

export default withStyles(styles)(Acompanhante);
